import { MobileNavigationHeader } from '@Components//happyFlowTemplate/MobileNavigationHeader.tsx';
import { PasswordlessDesktopSideBar } from '@Components//happyFlowTemplate/passwordlessDesktopSideBar/passwordlessDesktopSideBar';
import { useBoundStore } from '@Store/index.ts';
import { Outlet } from '@tanstack/react-router';
import { SupportDetails } from '@Components//supportDetails/SupportDetails';
import logoUrl from '@Assets/logos/lili-logo-blue.svg';

export const EdgeCaseTemplate = () => {
  const isEmbedded = useBoundStore((state) => state.onboardingSlice.getIsEmbedded());
  return (
    <div className='w-full h-full flex flex-col sm:flex-row items-center gap-[24px] sm:gap-0 fade-in'>
      <MobileNavigationHeader />
      {isEmbedded ? (
        <>
          <PasswordlessDesktopSideBar />
          <div className='flex flex-col overflow-hidden h-full sm:pt-[64px] gap-[32px] relative w-full'>
            <div className='h-full overflow-scroll flex  mx-auto no-scrollbar flex-col items-center p-[22px]'>
              <Outlet />
              {isEmbedded && (
                <div className='sm:hidden mb-[16px]'>
                  <SupportDetails />
                </div>
              )}
            </div>
          </div>
        </>
      ) : (
        <div className='w-full h-full bg-surface-primary-bw-02'>
          <div className='w-full max-w-[480px] tablet:max-w-[600px] flex flex-col tablet:pt-[203px] bg-surface-primary-bw-00 h-full tablet:ml-[103px] ml-[0px] tablet:pl-[103px] px-[24px]'>
            <img
              height={54}
              width={88}
              className='tablet:block hidden'
              src={logoUrl}
              alt='Lili logo'
            />
            <Outlet />
          </div>
        </div>
      )}
    </div>
  );
};
